<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="start">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">添加任务</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <router-link to="/admin/articleBot">
                            <a-button type="primary">
                                返回列表
                            </a-button>
                        </router-link>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="16" :offset="4" :style="{padding: '10px 24px 24px 24px'}">
                <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                >

                    <a-form-model-item label="所属网站" prop="website">
                        <a-select v-model="form.website" placeholder="请选择所属网站" @change="websiteChange">
                            <a-select-option v-for="item in website" :key="item.uuid" :value="item.uuid">
                                {{ item.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="文章标签" prop="tag">
                        <a-select v-model="form.tag" placeholder="请选择文章标签" @focus="checkWebsiteExist">
                            <a-select-option v-for="item in tag" :key="item.uuid" :value="item.uuid">
                                {{ item.title }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item ref="keyword" label="关键词" prop="keyword">
                        <a-input v-model="form.keyword"/>
                    </a-form-model-item>
                    <a-form-model-item ref="work" label="是否启用" prop="work" style="text-align: left;">
                        <a-switch v-model="form.work"/>
                    </a-form-model-item>

                    <a-form-model-item ref="perDayNum" label="每日数量" prop="perDayNum">
                        <a-input-number style="width: 100%" id="inputNumber" v-model="form.perDayNum" :min="1"
                                        :max="1000"/>
                    </a-form-model-item>

                    <a-form-model-item ref="spNum" label="段落数" prop="spNum">
                        <a-input-number style="width: 100%" id="spNum" v-model="form.spNum" :min="1" :max="10"/>
                    </a-form-model-item>

                    <a-form-model-item ref="minLen" label="最小字数" prop="minLen">
                        <a-input-number style="width: 100%" id="minLen" v-model="form.minLen" :min="150" :max="800"/>
                    </a-form-model-item>

                    <a-form-model-item ref="endDate" label="截止日期" prop="endDate" style="text-align: left;">
                        <a-date-picker v-model="form.endDate"/>
                    </a-form-model-item>

                    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                        <a-button v-if="$route.params.articleBotTask === 'add'" type="primary" @click="onSubmit">
                            新建任务
                        </a-button>
                        <a-button v-else type="primary" @click="onSubmit">
                            保存任务
                        </a-button>
                        <a-button style="margin-left: 10px;" @click="resetForm">
                            重置
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "ArticleBotAdd",
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
            form: {
                website: undefined,
                tag: '',
                work: false,
                endDate: null,
            },
            website: [],
            tag: [],
            rules: {
                website: {required: true, message: '必须选择归属网站', trigger: 'change'},
                tag: {required: true, message: '必须选择文章标签', trigger: 'change'},
                keyword: {required: true, message: '必须填写关键词', trigger: 'blur'},
                perDayNum: {required: true, message: '必须填写每日数量', trigger: 'blur'},
                minLen: {required: true, message: '必须填写最短字数', trigger: 'blur'},
                spNum: {required: true, message: '必须填写段落数', trigger: 'blur'},
            },
        };
    },
    methods: {

        getWebsite() {
            let that = this;
            this.$ajax.get(this.$host + "/admin/website/listAll", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.website = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        websiteChange() {
            this.form.tag = null;
            this.getArticleTag();
        },
        getArticleTag() {
            this.checkWebsiteExist();
            let that = this;
            this.$ajax.get(this.$host + "/admin/articleTag/listByWebsite", {
                params: {
                    website: this.form.website
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.tag = result.data;
                    if (that.tag.length > 0 && that.form.tag === null) {
                        that.form.tag = that.tag[0].uuid;
                    }
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        checkWebsiteExist() {
            if (this.form.website === null || this.form.website === undefined) {
                this.$message.info("请先选择文章所属网站");
            }
        },
        addSuccess() {
            let that = this;
            let text = '添加';
            if (this.$route.params.articleBotTask !== 'add') {
                text = '编辑';
            }
            this.$Modal.confirm({
                title: text + '任务成功',
                content: '已经成功' + text + '包含关键词《' + this.form.keyword + '》的任务，点击确定跳转到文章列表',
                okText: '好的',
                okType: 'danger',
                cancelText: '继续' + text,
                onOk() {
                    that.$router.push({path: "/admin/articleBot"});
                },
                onCancel() {
                    that.resetForm();
                },
            });
        },
        addPro() {
            let that = this;
            let param = {
                keyword: this.form.keyword,
                minLen: this.form.minLen,
                perDayNum: this.form.perDayNum,
                spNum: this.form.spNum,
                tag: this.form.tag,
                website: this.form.website,
                work: this.form.work,
                endDate: this.form.endDate.unix() * 1000
            };
            this.$ajax.post(this.$host + "/admin/articleBotTask/add", param).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        editPro() {
            let that = this;
            let param = {
                uuid:this.$route.params.articleBotTask,
                keyword: this.form.keyword,
                minLen: this.form.minLen,
                perDayNum: this.form.perDayNum,
                spNum: this.form.spNum,
                tag: this.form.tag,
                website: this.form.website,
                work: this.form.work,
                endDate: this.form.endDate.unix() * 1000
            };
            this.$ajax.post(this.$host + "/admin/articleBotTask/update", param).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.addSuccess();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        onSubmit() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.$route.params.articleBotTask === 'add') {
                        this.addPro();
                    } else {
                        this.editPro();
                    }
                } else {
                    this.$message.info("填写内容不合法，请检查");
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        getBaseData() {
            let that = this;
            this.$ajax.get(this.$host + "/admin/articleBotTask/details", {
                params: {
                    articleBotTask: this.$route.params.articleBotTask
                }
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    result.data.endDate = moment(result.data.endDate,'YYYY-MM-DD HH:mm:ss');
                    that.form = result.data;
                    that.getArticleTag();
                } else {
                    that.$message.info(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.getWebsite();
        if (this.$route.params.articleBotTask !== 'add') {
            this.getBaseData();
        }
    }
}
</script>

<style scoped>

</style>